module.exports = __webpack_public_path__ + "static/media/wedding-catering-4.18ed1255.jpg";